/** Component for line graphs with reference lines */
import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { CartesianGrid, Legend, LineChart, ReferenceLine, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { ReportData } from '../../../../model';
import { toLineGraphData } from '../DataFunctions/dataFunctions';
import { ApexOptions } from 'apexcharts';
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import Chart from 'react-apexcharts';
import { colorCS } from '../CustomGraphComponents';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';

type RespectTheSagittalPlaneGraphProps = {
  data: any;
};

export const RespectTheSagittalPlaneGraph = ({ data }: RespectTheSagittalPlaneGraphProps) => {
  const { width, height } = useWindowDimensions();
  const [windowSize, setWindowSize] = useState('small');

  useEffect(() => {
    if (height != null) {
      if (height > 860) {
        setWindowSize('large');
      } else {
        setWindowSize('small');
      }
      console.log('width', height);
    }
  }, [width]);

  const options: ApexOptions = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      offsetX: -10,
    },
    xaxis: {
      type: 'numeric',
      labels: {
        style: {
          fontSize: '8px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          return value.toFixed(2);
        },
        style: {
          fontSize: '8px',
        },
      },
      forceNiceScale: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
      },
    },
    grid: {
      show: true,
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    stroke: {
      width: [1],
      dashArray: [0],
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '9px',
      markers: {
        width: 8,
        height: 8,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
    },
    markers: {
      size: [0],
      strokeWidth: 0,
      showNullDataPoints: false,
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          borderColor: colorCS,
        },
      ],
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <>
      <div className='' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <Chart options={options} series={data} type='line' width='100%' height={windowSize === 'small' ? 140 : 225} />
      </div>
    </>
  );
};
